export default (function () {
  const tooltipSizes = {
    small: 150,
    medium: 200,
    large: 300,
  };

  function decorateAllTooltips() {
    document
      .querySelectorAll('.tooltip-open .js_toggle_popover')
      .forEach((toggleElement) => {
        let parentElement = toggleElement.parentElement;
        removeTooltipDecorators(parentElement);

        let tooltipSize = getTooltipSize(toggleElement);
        parentElement.classList.add('tooltip-size-' + tooltipSize);

        let tooltipAlignment = getTooltipAlignment(toggleElement, tooltipSize);
        parentElement.classList.add('tooltip-align-' + tooltipAlignment);
      });
  }

  function removeTooltipDecorators(tooltipElement) {
    tooltipElement.classList.remove(
      'tooltip-size-small',
      'tooltip-size-medium',
      'tooltip-size-large',
      'tooltip-align-left',
      'tooltip-align-center',
      'tooltip-align-right',
    );
  }

  function closeAllTooltips() {
    document.querySelectorAll('.tooltip-open').forEach((toggleElement) => {
      toggleElement.classList.remove('tooltip-open');
      removeTooltipDecorators(toggleElement);
    });
  }

  function getTooltipSize(toggleElement) {
    let parentElement = toggleElement.parentElement;
    let tooltipElement = parentElement.querySelector('.js_popover');
    if (tooltipElement.innerText.length < 30) {
      return 'small';
    }
    if (tooltipElement.innerText.length > 200) {
      return 'large';
    }
    return 'medium';
  }

  function getTooltipAlignment(toggleElement, tooltipSize) {
    let pos = toggleElement.getBoundingClientRect();

    if (window.innerWidth - pos.x < tooltipSizes[tooltipSize] / 2) {
      return 'right';
    }
    if (pos.x < tooltipSizes[tooltipSize] / 2) {
      return 'left';
    }
    return 'center';
  }

  function bindEvents() {
    document
      .querySelectorAll('.js_toggle_popover:not(.parsed)')
      .forEach((toggleElement) => {
        toggleElement.classList.add('parsed');

        toggleElement.addEventListener('click', (event) => {
          event.stopPropagation();

          let parentElement = toggleElement.parentElement;
          let clickedOnAlreadyOpenedTooltip = false;
          if (parentElement.classList.contains('tooltip-open')) {
            clickedOnAlreadyOpenedTooltip = true;
          }

          closeAllTooltips();

          if (!clickedOnAlreadyOpenedTooltip) {
            parentElement.classList.add('tooltip-open');
            decorateAllTooltips();
          }
        });
      });

    document.addEventListener('click', function (event) {
      if (event.target.closest('.js_popover') !== null) return;
      event.stopPropagation();
      closeAllTooltips();
    });

    let resizeTimer;
    window.onresize = function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(decorateAllTooltips, 100);
    };
  }

  function init() {
    bindEvents();
  }

  return {
    init: init,
  };
})();
